import { generatePath, useLocation, useNavigate } from "react-router-dom";
import { CALENDAR_SHIFT_DAY_ROUTE } from "../../../app/router/routes";
import { ShiftCalendarMonth } from "../../../widgets/shiftCalendarMonth";

const getDateParam = (date: Date): string => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export default function CalendarShiftPage() {

    const navigate = useNavigate()
    const location = useLocation()

    return (
        <ShiftCalendarMonth
            onSelectDate={date => {
                navigate({
                    pathname: generatePath(CALENDAR_SHIFT_DAY_ROUTE.path, {date: getDateParam(date)}),
                    search: location.search,
                })
            }}
        />
    )
}
